import { render, staticRenderFns } from "./CourseDiscussPanel.vue?vue&type=template&id=432573a9&scoped=true"
import script from "./CourseDiscussPanel.vue?vue&type=script&lang=js"
export * from "./CourseDiscussPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseDiscussPanel.vue?vue&type=style&index=0&id=432573a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432573a9",
  null
  
)

export default component.exports